import PropTypes from 'prop-types';
import ImageProp from '../../../commonComponents/propTypes/imageProp';

const propType = {
  _id: PropTypes.string.isRequired,
  code: PropTypes.string,
  image: PropTypes.shape(ImageProp.propType),
  duration: PropTypes.number,
  course: PropTypes.oneOfType([
    PropTypes.shape({ name: PropTypes.string }),
    PropTypes.string,
  ]),
};

const defaultProp = {
  code: '',
  image: {},
  duration: 0,
  course: {},
};

export default { propType, defaultProp };
